import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useFlexibleValidationFlag = () =>
  useBooleanFlagValue('flexible-validation-for-invoice-transaction', false);
